
import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const festivals = [
  {
    id: 1,
    title: "Houston Mediterranean Festival",
    date: "October 24-25, 2025",
    location: "St. George Orthodox Church, 5311 Mercer St., Houston",
    category: "Cultural",
    description: "Experience authentic Mediterranean culture through food, music, dance, and traditions at Houston's beloved annual celebration.",
    highlights: ["Traditional kabobs, falafel, gyro & za'atar", "Sweet baklava & Mediterranean desserts", "Kids zone & church tours", "Market, hookah, beer & wine"],
    image: "https://public.readdy.ai/ai/img_res/e3f2165a1409ecda70920d6716b54441.jpg"
  },
  {
    id: 2,
    title: "43rd Annual Galveston Island Oktoberfest",
    date: "October 24-25, 2025",
    location: "First Lutheran Church, 24th & Winnie, Historic Downtown Galveston",
    category: "Cultural",
    description: "Celebrate German heritage with authentic beer, bratwurst, live music, and coastal charm at Galveston's 43rd annual Oktoberfest.",
    highlights: ["Two stages of live music & dancing", "German dinner Friday & Saturday", "Kids activities & vendors", "Steinholding competitions"],
    image: "https://readdy.ai/api/search-image?query=Galveston%20Oktoberfest%20celebration%20with%20people%20in%20traditional%20German%20clothing%2C%20beer%20gardens%20by%20the%20ocean%2C%20live%20polka%20music%2C%20festive%20coastal%20atmosphere%2C%20authentic%20German%20festival%20vibes&width=400&height=300&seq=galveston-oktoberfest&orientation=landscape"
  },
  {
    id: 3,
    title: "12th Annual Magnolia Park Día de los Muertos Festival",
    date: "October 25, 2025",
    location: "Hidalgo Park, 7000 Ave Q, Houston (East End)",
    category: "Cultural",
    description: "Honor life and legacy through vibrant celebrations with parade, altars, and cultural performances in Houston's East End.",
    highlights: ["Morning parade at 9am", "Traditional altars & cultural performances", "Live music & authentic food", "Kids activities & artisan market"],
    image: "https://readdy.ai/api/search-image?query=Houston%20D%C3%ADa%20de%20los%20Muertos%20festival%20with%20colorful%20altars%2C%20families%20creating%20sugar%20skull%20art%2C%20traditional%20Mexican%20decorations%2C%20vibrant%20cultural%20celebration%2C%20marigold%20flowers%20and%20candles&width=400&height=300&seq=dia-muertos&orientation=landscape"
  },
  {
    id: 4,
    title: "Halloween in the Hangar",
    date: "October 25, 2025",
    location: "Lone Star Flight Museum, Ellington Airport",
    category: "Family",
    description: "Combine aviation history with Halloween fun in this unique family-friendly celebration featuring hands-on activities.",
    highlights: ["Trick-or-treating among aircraft", "Pumpkin parachute drop", "Catapult challenge & bat gliders", "Story time & photo ops"],
    image: "https://readdy.ai/api/search-image?query=Lone%20Star%20Flight%20Museum%20Halloween%20event%20with%20families%20in%20costumes%20exploring%20vintage%20aircraft%2C%20children%20participating%20in%20aviation-themed%20activities%2C%20festive%20hangar%20atmosphere%20with%20Halloween%20decorations&width=400&height=300&seq=halloween-hangar&orientation=landscape"
  },
  {
    id: 5,
    title: "6th Annual Hike, Bike & Fright Fest",
    date: "October 25, 2025",
    location: "M-K-T Heights Trail, 600 N Shepherd Dr.",
    category: "Outdoor",
    description: "Experience eco-friendly Halloween fun with trick-or-treat trail, plant market, and sustainable celebration activities.",
    highlights: ["Trick-or-treat trail", "HalloGreen plant market", "Kid & pet-friendly activities", "DJs & shopping deals"],
    image: "https://readdy.ai/api/search-image?query=Houston%20Heights%20trail%20Halloween%20bike%20event%20with%20families%20in%20costumes%20riding%20bikes%20on%20tree-lined%20paths%2C%20eco-friendly%20Halloween%20decorations%2C%20outdoor%20community%20celebration%20atmosphere&width=400&height=300&seq=bike-fright-fest&orientation=landscape"
  },
  {
    id: 6,
    title: "Boofest Kingwood",
    date: "October 25, 2025",
    location: "Kingwood Town Center Park, 8 N Main St.",
    category: "Community",
    description: "Discover suburban Houston's Halloween magic through this beloved community celebration with family-friendly activities.",
    highlights: ["Trick-or-treating stations", "Mini pumpkin patch", "Free train rides", "Live music & costume fun"],
    image: "https://readdy.ai/api/search-image?query=Kingwood%20Houston%20suburban%20Halloween%20festival%20with%20families%20in%20costumes%2C%20community%20parade%2C%20local%20vendors%2C%20tree-lined%20neighborhood%20celebration%2C%20family-friendly%20Halloween%20atmosphere&width=400&height=300&seq=boofest-kingwood&orientation=landscape"
  },
  {
    id: 7,
    title: "Scream on the Green",
    date: "October 25, 2025",
    location: "Discovery Green, 1500 McKinney St., Downtown",
    category: "Urban",
    description: "Join Houston's biggest costume party in the heart of downtown, featuring outdoor movie screening and urban Halloween festivities.",
    highlights: ["Costume contest (pre-registration required)", "Living sculptures & palm readers", "Games & entertainment", "Beetlejuice Beetlejuice movie screening"],
    image: "https://readdy.ai/api/search-image?query=Discovery%20Green%20Houston%20downtown%20Halloween%20event%20with%20large%20outdoor%20movie%20screen%2C%20people%20in%20costumes%20on%20grass%20with%20city%20skyline%20background%2C%20urban%20festival%20atmosphere%20at%20night&width=400&height=300&seq=scream-green&orientation=landscape"
  },
  {
    id: 8,
    title: "Diwali Lights! Festival",
    date: "October 26, 2025",
    location: "Asia Society Texas Center, 1370 Southmore Blvd.",
    category: "Cultural",
    description: "Celebrate the Festival of Lights with traditional performances, authentic cuisine, and cultural education highlighting Houston's diversity.",
    highlights: ["Family festival of lights", "Crafts, food & fashion", "Music & dance performances", "Ramayana performance (ticketed)"],
    image: "https://readdy.ai/api/search-image?query=Houston%20Diwali%20festival%20celebration%20with%20families%20lighting%20traditional%20oil%20lamps%2C%20colorful%20Indian%20decorations%2C%20cultural%20dance%20performances%2C%20festive%20lights%20and%20rangoli%20patterns&width=400&height=300&seq=diwali-festival&orientation=landscape"
  },
  {
    id: 9,
    title: "Sugar Land Día de los Muertos Celebration",
    date: "October 25, 2025",
    location: "Sugar Land Town Square, 2700 Town Center Blvd N",
    category: "Urban Cultural",
    description: "Experience authentic Mexican traditions with mariachi music, ballet folklórico, and cultural celebrations in Sugar Land.",
    highlights: ["Mariachi & ballet folklórico", "Aztec dancers performances", "Artisan market & authentic cuisine", "Family-friendly activities"],
    image: "https://readdy.ai/api/search-image?query=Sugar%20Land%20Town%20Square%20D%C3%ADa%20de%20los%20Muertos%20celebration%20with%20mariachi%20performers%2C%20colorful%20Mexican%20decorations%2C%20families%20celebrating%20cultural%20traditions%2C%20outdoor%20festival%20atmosphere&width=400&height=300&seq=sugar-land-muertos&orientation=landscape"
  },
  {
    id: 10,
    title: "Una Noche! Día de los Muertos",
    date: "October 31, 2025 (Halloween)",
    location: "Market Square Park, 301 Milam St., Downtown",
    category: "Urban Cultural",
    description: "Experience how Houston honors Mexican traditions on Halloween night with this downtown celebration of life and memory.",
    highlights: ["Evening mariachi & ballet folklórico", "Free face painting & arts workshops", "Community ofrenda with free photo printing", "Live music performances"],
    image: "https://readdy.ai/api/search-image?query=Market%20Square%20Park%20Houston%20downtown%20D%C3%ADa%20de%20los%20Muertos%20celebration%20with%20traditional%20altars%2C%20urban%20setting%20with%20skyscrapers%2C%20families%20celebrating%20Mexican%20culture%2C%20colorful%20decorations%20and%20marigolds&width=400&height=300&seq=market-square-muertos&orientation=landscape"
  }
];

const categories = ["All", "Cultural", "Family", "Outdoor", "Community", "Urban", "Urban Cultural"];

export default function FallFestivals() {
  const [selectedCategory, setSelectedCategory] = useState("All");

  const filteredFestivals = festivals.filter((festival) => {
    return selectedCategory === "All" || festival.category === selectedCategory;
  });

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Houston Fall Festivals & Cultural Events Guide",
    description: "Discover Houston's vibrant fall festival scene with cultural celebrations, family events, and community gatherings across the city.",
    url: `${import.meta.env.VITE_SITE_URL}/fall-festivals`,
    mainEntity: {
      "@type": "ItemList",
      itemListElement: festivals.map((festival, index) => ({
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@type": "Event",
          name: festival.title,
          description: festival.description,
          location: festival.location
        }
      }))
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      <SEO
        title="Houston Fall Festivals & Cultural Events Guide - Eric Javidi"
        description="Discover Houston's vibrant fall festival scene with Mediterranean celebrations, Oktoberfest, Día de los Muertos, Halloween events, and cultural festivals across the city."
        keywords="Houston festivals, Houston events, Mediterranean Festival Houston, Galveston Oktoberfest, Día de los Muertos Houston, Halloween events Houston, Diwali Houston, Discovery Green events"
        ogTitle="Houston Fall Festivals & Cultural Events Guide - Eric Javidi"
        ogDescription="Discover Houston's vibrant fall festival scene with cultural celebrations, family events, and community gatherings."
        ogUrl={`${import.meta.env.VITE_SITE_URL}/fall-festivals`}
        twitterTitle="Houston Fall Festivals & Cultural Events Guide - Eric Javidi"
        twitterDescription="Discover Houston's vibrant fall festival scene with cultural celebrations, family events, and community gatherings."
        jsonLd={jsonLd}
      />

      {/* Navigation */}
      <nav className="bg-neutral-800 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="text-xl font-semibold text-white">
                Eric Javidi
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link
                  to="/"
                  className="text-neutral-300 hover:text-green-400 px-3 py-2 text-sm font-medium"
                >
                  Home
                </Link>
                <Link
                  to="/about"
                  className="text-neutral-300 hover:text-green-400 px-3 py-2 text-sm font-medium"
                >
                  About
                </Link>
                <Link
                  to="/guides"
                  className="text-neutral-300 hover:text-green-400 px-3 py-2 text-sm font-medium"
                >
                  Guides
                </Link>
                <Link
                  to="/fall-festivals"
                  className="text-white hover:text-green-400 px-3 py-2 text-sm font-medium"
                >
                  Fall Festivals
                </Link>
                <Link
                  to="/resources"
                  className="text-neutral-300 hover:text-green-400 px-3 py-2 text-sm font-medium"
                >
                  Resources
                </Link>
                <Link
                  to="/contact"
                  className="text-neutral-300 hover:text-green-400 px-3 py-2 text-sm font-medium"
                >
                  Contact
                </Link>
              </div>
            </div>
            <div className="md:hidden">
              <button className="text-neutral-300 hover:text-white">
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-orange-500 to-red-600 text-white overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Houston%20fall%20festival%20scene%20with%20colorful%20cultural%20celebrations%2C%20families%20enjoying%20outdoor%20events%2C%20festive%20atmosphere%20with%20autumn%20decorations%2C%20diverse%20community%20gathering%2C%20vibrant%20festival%20energy&width=1200&height=600&seq=fall-festivals-hero&orientation=landscape')`
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-4xl lg:text-6xl font-bold mb-6">
              Houston Fall Festivals & Cultural Events
            </h1>
            <p className="text-xl lg:text-2xl mb-8 text-orange-100">
              Discover the vibrant tapestry of Houston's fall celebration scene, from Mediterranean feasts to Día de los Muertos traditions
            </p>
            <div className="flex items-center justify-center space-x-6 text-orange-100">
              <div className="flex items-center">
                <i className="ri-calendar-line mr-2"></i>
                <span>October 24-31, 2025</span>
              </div>
              <div className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                <span>Citywide Events</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-neutral-800 mb-6">
              Houston's Cultural Celebration Season
            </h2>
            <p className="text-lg text-neutral-600 leading-relaxed">
              Fall in Houston brings a spectacular array of cultural festivals that showcase the city's incredible diversity. From the Mediterranean flavors that have delighted families for decades to the sacred traditions of Día de los Muertos, these celebrations offer authentic glimpses into the communities that make Houston unique. Whether you're seeking family-friendly Halloween adventures or profound cultural experiences, Houston's fall festival scene provides meaningful connections to the city's rich heritage.
            </p>
            <div className="mt-6 p-4 bg-orange-50 rounded-lg">
              <p className="text-sm text-orange-700 italic">
                <i className="ri-information-line mr-2"></i>
                Festival dates, times, and details are subject to change. Please verify current information with event organizers before attending.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Category Filters */}
      <section className="py-8 bg-neutral-100 border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6">
            <h3 className="text-sm font-medium text-neutral-800 mb-3">
              Festival Categories
            </h3>
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer ${
                    selectedCategory === category
                      ? "bg-orange-600 text-white"
                      : "bg-white text-neutral-600 hover:bg-neutral-50"
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Festivals Grid */}
      <section className="py-16 bg-neutral-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredFestivals.map((festival) => (
              <Link
                key={festival.id}
                to={`/festival-detail/${festival.id}`}
                className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow cursor-pointer"
              >
                <div
                  className="h-48 bg-cover bg-center relative"
                  style={{ backgroundImage: `url('${festival.image}')` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-neutral-800/30 to-transparent"></div>
                  <div className="absolute top-3 right-3">
                    <span
                      className={`px-2 py-1 text-xs font-medium rounded-full ${
                        festival.category === "Cultural"
                          ? "bg-blue-100 text-blue-800"
                          : festival.category === "Family"
                          ? "bg-green-100 text-green-800"
                          : festival.category === "Outdoor"
                          ? "bg-emerald-100 text-emerald-800"
                          : festival.category === "Community"
                          ? "bg-purple-100 text-purple-800"
                          : festival.category === "Urban"
                          ? "bg-gray-100 text-gray-800"
                          : "bg-orange-100 text-orange-800"
                      }`}
                    >
                      {festival.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm text-orange-600 font-medium">
                      {festival.date}
                    </span>
                  </div>
                  <h3 className="text-xl font-semibold text-neutral-800 mb-2">
                    {festival.title}
                  </h3>
                  <p className="text-neutral-600 mb-4 text-sm">
                    {festival.description}
                  </p>
                  <div className="mb-4">
                    <h4 className="text-sm font-medium text-neutral-800 mb-2">Highlights:</h4>
                    <ul className="text-xs text-neutral-600 space-y-1">
                      {festival.highlights.map((highlight, index) => (
                        <li key={index} className="flex items-start">
                          <i className="ri-check-line text-orange-500 mr-1 mt-0.5 flex-shrink-0"></i>
                          <span>{highlight}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="flex items-center text-sm text-neutral-500">
                    <i className="ri-map-pin-line mr-1"></i>
                    <span className="truncate">{festival.location}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Planning Your Festival Experience */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-neutral-800 mb-8 text-center">
            Planning Your Festival Experience
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-check-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-neutral-800 mb-3">
                Check Event Dates
              </h3>
              <p className="text-neutral-600 text-sm">
                Festival dates can change year to year. Always verify current schedules and ticket requirements before attending.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-car-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-neutral-800 mb-3">
                Plan Transportation
              </h3>
              <p className="text-neutral-600 text-sm">
                Popular festivals can have limited parking. Consider rideshare, public transit, or carpooling for easier access.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-group-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-neutral-800 mb-3">
                Bring the Family
              </h3>
              <p className="text-neutral-600 text-sm">
                Most Houston festivals are designed with families in mind, offering activities and experiences for all ages.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Cultural Context */}
      <section className="py-16 bg-orange-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-neutral-800 mb-8 text-center">
            Why Houston's Festival Scene Matters
          </h2>
          <div className="prose prose-lg mx-auto text-neutral-700">
            <p className="mb-6">
              Houston's fall festivals represent more than entertainment—they're living expressions of the city's cultural DNA. The Mediterranean Festival connects us to the Greek, Lebanese, and Italian families who helped build Houston's early commercial districts. Día de los Muertos celebrations honor the Mexican heritage that shapes entire neighborhoods like the East End and Magnolia Park.
            </p>
            <p className="mb-6">
              These events serve as bridges between generations, allowing longtime residents to share their traditions while welcoming newcomers into Houston's cultural tapestry. From the German heritage celebrated at Galveston's Oktoberfest to the South Asian traditions showcased during Diwali, each festival adds another layer to Houston's identity as one of America's most diverse cities.
            </p>
            <p>
              For Eric Javidi, these festivals represent the same storytelling principles that guide his neighborhood walks and cultural tours—they reveal how Houston's past continues to shape its present, creating spaces where history, community, and celebration intersect.
            </p>
          </div>
        </div>
      </section>

      {/* Related Guides */}
      <section className="py-16 bg-neutral-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-neutral-800 mb-8 text-center">
            Explore More Houston Stories
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <Link to="/guides/3" className="bg-white rounded-lg overflow-hidden hover:shadow-md transition-shadow cursor-pointer">
              <div className="h-32 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Houston%20East%20End%20neighborhood%20with%20authentic%20Mexican%20taqueria%20storefronts%2C%20colorful%20murals%2C%20street%20food%20culture%2C%20vibrant%20community%20atmosphere%2C%20local%20flavor%20and%20cultural%20heritage&width=300&height=200&seq=eastend-related-fest&orientation=landscape')`
              }}></div>
              <div className="p-4">
                <h3 className="font-semibold text-neutral-800 mb-1">East End Taquería Trail</h3>
                <p className="text-sm text-neutral-600">Explore Houston's Mexican culinary heritage</p>
              </div>
            </Link>
            
            <Link to="/guides/7" className="bg-white rounded-lg overflow-hidden hover:shadow-md transition-shadow cursor-pointer">
              <div className="h-32 bg-cover bg-center" style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Houston%20Heights%20neighborhood%20at%20twilight%20during%20Halloween%20season%20with%20historic%20bungalow%20houses%20decorated%20for%20Halloween%2C%20orange%20autumn%20leaves%2C%20spooky%20decorations%2C%20jack-o-lanterns%20on%20porches%2C%20evening%20atmosphere%20with%20warm%20street%20lights%2C%20family-friendly%20Halloween%20vibes&width=300&height=200&seq=halloween-related-fest&orientation=landscape')`
              }}></div>
              <div className="p-4">
                <h3 className="font-semibold text-neutral-800 mb-1">Halloween Heights Ghost Walk</h3>
                <p className="text-sm text-neutral-600">Spooky stories & historic hauntings</p>
              </div>
            </Link>
            
            <Link to="/guides" className="bg-orange-50 rounded-lg p-6 flex items-center justify-center text-center hover:bg-orange-100 transition-colors cursor-pointer">
              <div>
                <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-arrow-right-line text-white"></i>
                </div>
                <h3 className="font-semibold text-orange-800 mb-1">View All Guides</h3>
                <p className="text-sm text-orange-600">Discover more Houston stories</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-neutral-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-xl font-semibold mb-4">Eric Javidi</h3>
              <p className="text-neutral-300 mb-4">
                Houston-based storyteller exploring where the city's history meets its natural landscapes.
              </p>
              <div className="flex items-center space-x-4">
                <a
                  href="https://www.youtube.com/@EricJavidi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-neutral-300 hover:text-red-400 transition-colors"
                  aria-label="YouTube Channel"
                >
                  <i className="ri-youtube-fill text-2xl"></i>
                </a>
                <a
                  href="https://www.facebook.com/ericjavidihouston/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-neutral-300 hover:text-blue-400 transition-colors"
                  aria-label="Facebook Page"
                >
                  <i className="ri-facebook-fill text-2xl"></i>
                </a>
              </div>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-neutral-300 hover:text-white">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/guides" className="text-neutral-300 hover:text-white">
                    Guides
                  </Link>
                </li>
                <li>
                  <Link to="/fall-festivals" className="text-neutral-300 hover:text-white">
                    Fall Festivals
                  </Link>
                </li>
                <li>
                  <Link to="/resources" className="text-neutral-300 hover:text-white">
                    Resources
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-neutral-300 hover:text-white">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Connect</h4>
              <ul className="space-y-2">
                <li><a href="https://www.youtube.com/@EricJavidi" target="_blank" rel="noopener noreferrer" className="text-neutral-300 hover:text-white">YouTube Channel</a></li>
                <li><a href="https://www.facebook.com/ericjavidihouston/" target="_blank" rel="noopener noreferrer" className="text-neutral-300 hover:text-white">Facebook Page</a></li>
                <li>
                  <a href="https://readdy.ai/?origin=logo" className="text-neutral-300 hover:text-white">
                    Made with Readdy
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-neutral-700 mt-8 pt-8 text-center">
            <p className="text-neutral-400">© 2024 Eric Javidi. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
